<template>
  <div>
      <a-descriptions :column="1">
        <a-descriptions-item label="Code / Mã nhân viên">
          {{ employee.code }}
        </a-descriptions-item>
        <a-descriptions-item label="Fullname / Tên nhân viên">
          {{ employee.fullname }}
        </a-descriptions-item>
        <a-descriptions-item label="Gender / Giới tính">
          <span v-if="employee.gender === 'NONE'"> Other </span>
          <span v-else-if="employee.gender === 'MALE'"> Male </span>
          <span v-else-if="employee.gender === 'FEMALE'">Female</span>
        </a-descriptions-item>
        <a-descriptions-item label="Birthday / Ngày sinh">
          {{ employee.birthday | formatDate }}
        </a-descriptions-item>
        <a-descriptions-item label="Email">
          {{ employee.email }}
        </a-descriptions-item>
        <a-descriptions-item label="Account / Người dùng">
          {{ employee.user && employee.user.fullname }}
        </a-descriptions-item>
        <a-descriptions-item label="Department / Phòng ban" v-if="employee.department">
          <span
            v-if="
              employee.department && employee.department.status === 'DEACTIVE'
            "
          >
            <del> {{ employee.department.name }} </del>
          </span>
          <span
            v-else-if="
              employee.department && employee.department.status === 'ACTIVE'
            "
          >
            {{ employee.department.name }}
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="Position / Chức vụ" v-if="employee.position">
          <span
            v-if="employee.position && employee.position.status === 'DEACTIVE'"
          >
            <del> {{ employee.position.name }} </del>
          </span>
          <span
            v-else-if="
              employee.position && employee.position.status === 'ACTIVE'
            "
          >
            {{ employee.position.name }}
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="Location / Địa điểm làm việc" v-if="employee.branchLocation">
          <span v-if="employee.branchLocation">
            {{ employee.branchLocation.name }}
          </span>
        </a-descriptions-item>
        <!-- <a-descriptions-item label="Người tạo">
          {{ employee.author && employee.author.fullname }}
        </a-descriptions-item>
        <a-descriptions-item label="Ngày tạo">
          {{ employee.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Cập nhật lần cuối">
          {{ employee.updatedAt | formatDateHour }}
        </a-descriptions-item> -->
      </a-descriptions>
  </div>
</template>
<script>
export default {
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visibleUpdateEmployee: false,
    };
  },
};
</script>
